import { render, staticRenderFns } from "./Enterprise-Certification.vue?vue&type=template&id=1639d44a&scoped=true&"
import script from "./Enterprise-Certification.vue?vue&type=script&lang=js&"
export * from "./Enterprise-Certification.vue?vue&type=script&lang=js&"
import style0 from "./Enterprise-Certification.vue?vue&type=style&index=0&id=1639d44a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1639d44a",
  null
  
)

export default component.exports